import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for setting and retrieving interview data
 */
const create = () => {
    // Create and configure an apisauce-based api object.
    const api = BaseApi.create();

    const loadInterview = (taxYear) => api.get(ApiPaths.GET_INTERVIEW(taxYear));
    const saveInterview = (taxYear, interview, isComplete, page) => {
        var payload = {
            taxYear: taxYear,
            currentPage: page,
            interview: JSON.stringify(interview)
        }
        return api.post(ApiPaths.SAVE_INTERVIEW(isComplete), payload)
    }

   
    // Return back a collection of functions
    return {
        loadInterview, saveInterview
    }
}

// let's return back our create method as the default.
export default {
    create
}